import React from "react";

function BusinessLeagueModel() {
  return (
    <>
     
       <div id="inner-hero" className="inner-hero bg-com pt-50 pb-50">
        <div classNameName="container">
            <div classNameName="row">
                <div className="col-lg-12">
                    <div className="inner-text text-center">
                        <div className="inner-title">Business League Model</div>
                        <ul className="inner-link">
                            <li>Home</li>
                            <li>Business League Model</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>


     <section id="about-us" className="about-two pt-50 pb-50">
        <div className="container">
            <div className="row">
                <div className="col-lg-4">
                    <div className="about-img">
                        <img src="/assets/img/business-model.JPG" className="img-fluid img-thumbnail"/>
                       
                        
                    </div>
                </div>
                <div className="col-lg-8">
                    <div className="about-content">
                        <div className="section-content">
                         
                            <h2 className="section-title">The Business League Model</h2>
                            <div className="section-border"><span></span></div>
                        </div>

                       
                        <div className="about-text">
                             <h3>"Come, be a part of India's most exclusive business chamber"</h3>
                                
                                <ul className="home-three-about-list">
                                <li>"Think of our chamber like a professional sports league structured, profitable, and valuable for all participants." </li>
                                <li>Chamber - League Franchise Structured organization with clear rules, professional management,
and growth potential that benefits all stakeholders.
</li>

                             <li>Members - Teams Strategic investment in membership provides exclusive access, competitive
advantages, and measurable returns through networking and business opportunities.
</li>

<li>Events - Matches Regular programming generates revenue, increases visibility, and creates
opportunities for members to showcase capabilities and build relationships.</li>

<li>Sponsors - Partners Corporate backing funds growth initiatives while providing sponsors targeted
access to qualified business decision makers and community leaders.</li>
                               
                                   </ul>

                        </div>   
                       
                    </div>
                </div>
            </div>
        </div>
    </section>



     <section id="about-team-information" className="about-team-information-area pt-130 pb-130">
        <div className="container">
            <div className="row">
              
                <div className="col-lg-12">
                    <div className="about-team-information-right row">
                        <div className="col-md-3 col-sm-3">
                            <div className="about-team-information-item">
                                <div className="about-information-icon">
                                    <img src="/assets/img/teams-icon.png"/>
                                </div>
                                <h4>A Great Team</h4>
                               
                            </div>
                        </div>
                          <div className="col-md-3 col-sm-3">
                            <div className="about-team-information-item">
                                <div className="about-information-icon">
                                    <img src="/assets/img/dedicated-icon.png"/>
                                </div>
                                <h4>We Are Dedicated</h4>
                              
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <div className="about-team-information-item">
                                <div className="about-information-icon">
                                    <img src="/assets/img/support-icon.png"/>
                                </div>
                                <h4>Life Time Support</h4>
                              
                            </div>
                        </div>
                       <div className="col-md-3 col-sm-3">
                            <div className="about-team-information-item">
                                <div className="about-information-icon">
                                    <img src="/assets/img/dependable-team-icon.png" />
                                </div>
                                <h4>Dependable Team</h4>
                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    </>
  );
}

export default BusinessLeagueModel;